/**
 * @graphql cc
 */
import { useQuery } from '@apollo/react-hooks';

import type { SpaceType } from '@confluence/content-types-bridge/entry-points/container-types-shell-types';

import type {
	SpaceQueryWhiteboards,
	SpaceQueryWhiteboardsVariables,
	SpaceQueryWhiteboards_space,
	SpaceQueryWhiteboards_space_icon,
} from './__types__/SpaceQuery';
import { SpaceQuery } from './SpaceQuery.graphql';

export type UseSpaceQueryResult = {
	id: SpaceQueryWhiteboards_space['id'] | undefined;
	name: SpaceQueryWhiteboards_space['name'] | undefined;
	iconPath: SpaceQueryWhiteboards_space_icon['path'] | undefined;
};

/**
 * Provides requisite space data for all whiteboard routes.
 * @param spaceKey
 * @param spaceFromProps
 * @returns
 */
export const useSpace = (spaceKey: string, spaceFromProps?: SpaceType): UseSpaceQueryResult => {
	const result = useQuery<SpaceQueryWhiteboards, SpaceQueryWhiteboardsVariables>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		SpaceQuery,
		{
			skip: !!spaceFromProps,
			variables: { spaceKey },
		},
	);

	if (spaceFromProps) {
		return {
			id: spaceFromProps.id,
			name: spaceFromProps.name,
			iconPath: spaceFromProps.iconPath ?? '',
		};
	} else {
		const space = result.data?.space;
		return { id: space?.id, name: space?.name, iconPath: space?.icon?.path };
	}
};
